import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import {
  FlexView,
  Button,
  FlexViewTable,
  TableHeader,
  TableList,
  TitleCard,
  Main,
  Spinner,
} from '../components/common'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../stores/AppStore'
import { UserContext } from 'stores/UserStore'
import * as XLSX from 'xlsx'
import { SmartContext } from 'stores/SmartStore'
import { RiFileExcel2Line } from 'react-icons/ri'
import { DatePicker } from 'components/form'

const ButtonExcel = styled(Button)`
  padding: 8px 16px;
  border-radius: 4px;
  background: ${({ background }) => background};
  color: ${(color) => color};
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
`

const Home = () => {
  const DatePickerFrom = (props) => {
    return <DatePicker value={fromDate} onChange={setFromDate} {...props} />
  }

  const DatePickerTo = (props) => {
    return <DatePicker value={toDate} onChange={setTODate} {...props} />
  }

  const DEFAULT_URL = 'collaborative-design/home'

  const { t } = useTranslation()

  const { setPageSubtitle } = useContext(AppContext)
  const { registryLog, registryLogOld } = useContext(UserContext)
  const { tableData, getReportData, searchData, isLoading } = useContext(
      SmartContext
  )
  const [fromDate, setFromDate] = useState()
  const [toDate, setTODate] = useState()

  const columns = [
    {
      Header: t('report.application'),
      accessor: 'application',
      id: 'application',
    },
    {
      Header: t('report.date'),
      accessor: (row) =>
          new Date(row.date).toLocaleDateString('pt-br', { timeZone: 'utc' }),
      id: 'date',
    },
    {
      Header: t('report.type'),
      accessor: 'type',
      id: 'type',
    },
    {
      Header: t('report.documentId'),
      accessor: 'documentId',
      id: 'documentoId',
    },
    {
      Header: t('report.signer'),
      accessor: 'signer',
      id: 'signer',
    },
    {
      Header: t('report.logged'),
      accessor: 'logged',
      id: 'logged',
    },
  ]

  const onExcelClick = () => {
    const sheets = []
    sheets.push({
      data: tableData.map((row) => {
        const obj = {}
        obj[t('report.application')] = row.application
        obj[t('report.date')] = row.date
        obj[t('report.type')] = row.type
        obj[t('report.documentId')] = row.documentId
        obj[t('report.signer')] = row.signer
        obj[t('report.logged')] = row.logged
        return obj
      }),
      name: t('report.title'),
    })
    const workbook = { SheetNames: [], Sheets: {} }
    sheets.forEach(function(row) {
      const sheetName = row.name
      const worksheet = XLSX.utils.json_to_sheet(row.data)
      workbook.SheetNames.push(sheetName)
      workbook.Sheets[sheetName] = worksheet
    })
    const options = { bookType: 'xlsx', type: 'array' }
    XLSX.writeFile(workbook, 'smart-report' + Date.now() + '.xlsx', options)

    registryLog('signatures', "click", "export_excel")
  }

  const onSearchClick = () => {
    searchData({ fromDate, toDate })
    registryLog('signatures', "click", "search")
  }

  useEffect(() => {
    setPageSubtitle(t('home.pageTitle'))
    registryLogOld('client_in', DEFAULT_URL)
    registryLog('signatures', "navigation", "client_in")
    getReportData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
      <FlexViewTable>
        {!isLoading ? (
            <Main>
              <TableHeader>
                <DatePickerFrom label={t('report.from')} name="from" /> &nbsp;&nbsp;
                <DatePickerTo label={t('report.to')} width="100%" name="to" />{' '}
                &nbsp;&nbsp;
                <TitleCard>
                  <Button
                      style={{ marginTop: '20px' }}
                      backgroundColor="primary"
                      color="white"
                      fontSize="small"
                      elevation="medium"
                      onClick={onSearchClick}
                  >
                    {' '}
                    &nbsp;
                    {t('report.search')}
                  </Button>{' '}
                  &nbsp; &nbsp;
                  <ButtonExcel
                      style={{ marginTop: '20px', backgroundColor: '#e5e5e5' }}
                      color="primary"
                      fontSize="small"
                      onClick={onExcelClick}
                  >
                    <RiFileExcel2Line
                        style={{ width: '35px', height: '35px', color: '#59CBE4' }}
                        onClick={() => onExcelClick()}
                    />
                  </ButtonExcel>
                </TitleCard>
              </TableHeader>
              <TableList
                  width="100%"
                  columns={columns}
                  data={tableData}
                  sortable
                  elevation="none"
                  borderRadius="card"
                  paginated
                  margin="8px 16px"
                  style={{ whiteSpace: 'nowrap' }}
              />
            </Main>
        ) : (
            <FlexView
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
            >
              <Spinner />
            </FlexView>
        )}
      </FlexViewTable>
  )
}
export default Home
